import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTopOnMount = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Si un hash est présent dans l'URL (ex: /glossaire#macronutriments)
    // on laisse le navigateur gérer le scroll vers la section
    if (hash) {
      // Petit délai pour laisser le temps à la page de charger
      setTimeout(() => {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      // Sinon, on scroll en haut de la page
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
};

export default ScrollToTopOnMount;
